import React from 'react';
import styled, { css } from 'styled-components';

export const Input = styled.input.attrs({
  type: 'text'
})`
	/* Adapt the colours based on primary prop */
	color: #444;
	background-color: ${props => '#f3f3f3'};
	border: none;
	border-radius: 0;
	text-align: center;
	
	&:focus {
	  background-color: ${props => '#ffffff'};
	}
	
`;



// WEBPACK FOOTER //
// ./src/components/Input.js